import { Modal, Table, Typography, Tooltip } from "antd";
import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDetails } from "services/redux/email/emaildelivery/action";
// import {
//   mailDeliveryGetDetailsResponse,
//   mailDeliveryGetDetailsResponseLoadinG,
// } from "services/redux/email/emaildelivery/reducer";

const DeliveryStatusModal = ({
  modalVisible,
  setModalVisible,
  MailHeaderId,
}) => {
  const dispatch = useDispatch();

  const {
    mailDeliveryGetDetailsResponse,
    mailDeliveryGetDetailsResponseLoadinG,
  } = useSelector((state) => state.mailDeliveryStatus);

  useEffect(() => {
    if (!modalVisible) return;
    console.log("MailHeaderId", MailHeaderId);
    dispatch(getDetails(MailHeaderId));
  }, [modalVisible]);

  const columns = [
    {
      title: "Status Datetime",
      dataIndex: "statusDatetime",
      key: "statusDatetime",
      render: (text) => moment(text).format("DD/MM/YYYY hh:mm:ss A"),
    },
    {
      title: "Email Status",
      dataIndex: "emailStatus",
      key: "emailStatus",
      render: (text) => <Typography.Text>{text}</Typography.Text>,
    },
    {
      title: "Email From",
      dataIndex: "emailFrom",
      key: "emailFrom",
      render: (text) => <Typography.Text>{text}</Typography.Text>,
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
      render: (text) => <Typography.Text>{text}</Typography.Text>,
    },
  ];

  return (
    <>
      <Modal
        visible={modalVisible}
        // title="Summary of Income ${modalData?.colTitle ? modalData?.colTitle} : null}`"
        title={`Summary of  Mail Delivery Status `}
        onCancel={() => {
          console.log("setModalVisible", modalVisible);
          setModalVisible(false);
        }}
        footer={null}
        width={1000}
      >
        <Table
          className="next-organizer-table"
          dataSource={mailDeliveryGetDetailsResponse}
          columns={columns}
          loading={mailDeliveryGetDetailsResponseLoadinG}
          pagination={false}
        />
      </Modal>
    </>
  );
};

export default DeliveryStatusModal;
